import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';
import ZoomOutMap from '@material-ui/icons/ZoomOutMap';
import common from '@material-ui/core/colors/common';

class MapFitBounds extends Component {
  render() {
    const { t } = this.props;
    return (
      <Tooltip title={t('buttons.mapFitBounds')}>
        <Button variant="contained" size="small" style={{ minWidth: 0, backgroundColor: common.white }} onClick={this.props.onClick}>
          <ZoomOutMap/>
        </Button>
      </Tooltip>
    );
  }
}

MapFitBounds.propTypes = {
  t: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default withNamespaces()(MapFitBounds);



// WEBPACK FOOTER //
// ./src/components/MapFitBounds.js